import { CAR_MODELS } from '../constants'

export const VEHICLE_OTHER = 'Other'
export const MAX_LICENSE_PLATE_NUMBER_CHARS = 8

export const processVehicleTypes = vehicleTypes => {
  const vehicleTypesArray = []
  for (const key of Object.keys(vehicleTypes)) {
    const obj = vehicleTypes[key]
    obj.value = key
    vehicleTypesArray.push(obj)
  }

  return vehicleTypesArray
}

export const checkNeedsLicenseInfo = (fields, vehicleTypes) => {
  if (vehicleTypes) {
    const vehicle = processVehicleTypes(vehicleTypes).filter(
      key => parseInt(key.value, 10) === parseInt(fields.vehicleType.value, 10)
    )

    if (typeof vehicle !== 'undefined' && vehicle.length !== 0) {
      return vehicle[0].needs_license_info
    }
  }

  return false
}

export type OptionType = {
  name: string
  value: string
}

export const arrayToOptions = (opts: string[], translations?: { [key: string]: () => string }): OptionType[] =>
  opts.map(o => ({ name: (translations && translations[o]) ? translations[o]() : o, value: o }))

export const modelOptions = (make: string): OptionType[] => {
  if (make === '') {
    return []
  }
  if (make === VEHICLE_OTHER) {
    return [{ name: VEHICLE_OTHER, value: VEHICLE_OTHER }]
  }
  return arrayToOptions(['', ...CAR_MODELS[make], VEHICLE_OTHER])
}
